import styled from 'styled-components'

const CarouselContainer = styled.div`
  display: flex;
  margin: 0 0 0 1rem;
  transition: ${props => (props.sliding ? 'none' : 'transform 0.5s ease')};

  transform: ${props => {
    if (!props.sliding) return 'translateX(calc(-80% - 1rem))'
    return 'translateX(0%)'
  }};
`

export default CarouselContainer



// WEBPACK FOOTER //
// ./src/components/shared/Carousel/CarouselContainer.js